<div class="preview-container" id="preview-container">
  @if (loading) {
    <section id="loader-container">
      <ng-casto-loader></ng-casto-loader>
    </section>
  }

  <div class="d-flex flex-wrap align-items-center justify-content-center overflow-auto mt-auto mb-auto">
    @for (resumeGroup of resumeGroups; track resumeGroup.id; let index = $index) {
      <ng-fence-preview-resume-groups
        [group]="resumeGroup"
        [index]="index"
        [isVertical]="resumeGroup.isVertical"
        (groupLoaded)="onGroupLoaded(resumeGroup)"></ng-fence-preview-resume-groups>
    } @empty {
      <ng-casto-loader></ng-casto-loader>
    }

    @if (differentHeights && differentHeights.length > 1) {
      <h6 class="text-center mt-2">Le nombre de lames peut varier suivant la hauteur du poteau</h6>
    }
  </div>
</div>
